import { useEffect, useState } from 'react';
import { data_from_server_post } from '@/shared/http/client';

/**
 * Distinct values of the detected `dataset_card` column (the public hub ids
 * the Retrieval Agent stamps on each record), powering the Data Editor's
 * checkbox column filter (same design as Sample Origin).
 *
 * Fetched lazily — only while the column is visible (`enabled`) — and
 * re-fetched when the task or the dataset/benchmark tab changes.
 */
export function useDatasetCardFilterValues(currentUsecase, isBenchmark, enabled) {
    const [values, setValues] = useState([]);
    const clientId = currentUsecase?.client_id;
    const usecaseId = currentUsecase?._id;

    useEffect(() => {
        if (!enabled || !clientId || !usecaseId) return undefined;
        let cancelled = false;
        data_from_server_post(
            'dataset-records/extra-param-values',
            {
                client_id: clientId,
                llm_usecase_id: usecaseId,
                is_benchmark: Boolean(isBenchmark),
                key: 'dataset_card',
            },
            (result) => {
                if (cancelled) return;
                setValues(Array.isArray(result?.values) ? result.values : []);
            },
            () => {
                if (cancelled) return;
                setValues([]);
            }
        );
        return () => {
            cancelled = true;
        };
    }, [enabled, clientId, usecaseId, isBenchmark]);

    return values;
}
